import moment from 'moment';

export default function formatDate (input,format='DD/MM/YYYY') {
    if (!input) return '';

    var timestamp = Date.parse(input);

    if (isNaN(timestamp)) {    
        return input;
    }

    // Detect current locale
    const currentLocale = moment.locale();

    // Special handling for time format
    if (format === 'TIME_FORMAT') {
        format =
        currentLocale === 'de'
            ? 'HH:mm'
            : 'h:mm A';
    }

    // Special handling for Date + time
    if (format === 'DATETIME_FORMAT') {
        format =
        currentLocale === 'de'
            ? 'DD/MM/YY - HH:mm'
            : 'DD/MM/YY - h:mm A';
    }

    return moment(new Date(input)).format(format);
}